import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_STORE_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    localStorage.removeItem('authtoken');
  }

  return result;
};

export const VendorWarehouseApi = createApi({
  reducerPath: 'VendorWarehouseApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Warehouse'],
  endpoints: (builder) => ({


    getVendorWarehouses: builder.query({
      query: () => ({
        url: `/warehouse/vendor-warehouses-list/`,
      }),
      providesTags: ['Warehouse'],
    }),


    createWarehouse: builder.mutation({
      query: (payload) => ({
        url: `/warehouse/create-warehouse/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Warehouse'],
    }),

  }),
});


export const {
  useGetVendorWarehousesQuery,
  useCreateWarehouseMutation,
} = VendorWarehouseApi;
